

const colors = {
    transparent: getComputedStyle(document.body).getPropertyValue('--color-transparent')
}

export default { colors }